import { useEffect, useState } from 'react';
import MuiDialog from '../../../UI/MuiDialog/MuiDialog';
import GridProviderUsluge from './gridProviderUsluge';
import Paneli from './Paneli/Paneli';
import useHttp from '../../../../hooks/use-http';
import { urls } from '../api/urls';
import GridProviderTransport from './GridProviderTransport';
import GridProviderDelovi from './GridProviderDelovi';
import GridProviderTroskovi from './GridProviderTroskovi';

const PanelProvider = ({ panelData = {} }) => {
  console.log('PANEL DATA', panelData);
  const {
    sendRequest: getUsluge,
    data: uslugeData,
    isLoading: isLoadingUsluge,
  } = useHttp('');
  const {
    sendRequest: getTransport,
    data: transportData,
    isLoading: isLoadingTransport,
  } = useHttp('');
  const {
    sendRequest: getDelovi,
    data: deloviData,
    isLoading: isLoadingDelovi,
  } = useHttp('');
  const {
    sendRequest: getTroskovi,
    data: troskoviData,
    isLoading: isLoadingTroskovi,
  } = useHttp('');

  const [openUslugeDialog, setOpenUslugeDialog] = useState(false);
  const [openTransportDialog, setOpenTransportDialog] = useState(false);
  const [openDeloviDialog, setOpenDeloviDialog] = useState(false);
  const [openTroskoviDialog, setOpenTroskoviDialog] = useState(false);

  useEffect(() => {
    const configUsluge = {
      method: 'POST',
      url: urls.GET_USLUGE_DETALJI,
      data: { id: panelData.id },
    };
    getUsluge(configUsluge);
    const configTransport = {
      method: 'POST',
      url: urls.GET_TRANSPORT_DETALJI,
      data: { id: panelData.id },
    };
    getTransport(configTransport);
    const configDelovi = {
      method: 'POST',
      url: urls.GET_DELOVI_DETALJI,
      data: { id: panelData.id },
    };
    getDelovi(configDelovi);
    const configTroskovi = {
      method: 'POST',
      url: urls.GET_TROSKOVI_DETALJI,
      data: { id: panelData.id },
    };
    getTroskovi(configTroskovi);
  }, [panelData.id]);

  const openUsluge = () => {
    setOpenUslugeDialog(true);
  };
  const openTransport = () => {
    setOpenTransportDialog(true);
  };
  const openDelovi = () => {
    setOpenDeloviDialog(true);
  };
  const openTroskovi = () => {
    setOpenTroskoviDialog(true);
  };

  const listaPanela = [
    {
      naslov: 'Usluge: ',
      bgColor: '#44BDC9',
      colorText: 'white',
      colorUkupno: 'white',
      suma: Object.keys(panelData).length === 0 ? 0 : panelData.dobitZaposleni,
      handleClick: openUsluge,
    },
    {
      naslov: 'Transport: ',
      bgColor: '#F4535F',
      colorText: 'white',
      colorUkupno: 'white',
      suma:
        Object.keys(panelData).length === 0 ? 0 : panelData.dobitZaposleniTr,
      handleClick: openTransport,
    },
    {
      naslov: 'Delovi: ',
      bgColor: '#0073C8',
      colorText: 'white',
      colorUkupno: 'white',
      suma: Object.keys(panelData).length === 0 ? 0 : panelData.dobitDelovi,
      handleClick: openDelovi,
    },
    {
      naslov: 'Troškovi: ',
      bgColor: '#0073C8',
      colorText: 'white',
      colorUkupno: 'white',
      suma: Object.keys(panelData).length === 0 ? 0 : panelData.dobitTrosak,
      handleClick: openTroskovi,
    },
  ];

  return (
    <>
      <Paneli listaPanela={listaPanela} />
      <MuiDialog
        maxWidth="xl"
        open={openUslugeDialog}
        title="Usluge"
        content={
          <GridProviderUsluge data={uslugeData} isLoading={isLoadingUsluge} />
        }
        handleClose={() => setOpenUslugeDialog(false)}
        deniedText="ZATVORI"
      />
      <MuiDialog
        maxWidth="xl"
        open={openTransportDialog}
        title="Transport"
        content={
          <GridProviderTransport
            data={transportData}
            isLoading={isLoadingTransport}
          />
        }
        handleClose={() => setOpenTransportDialog(false)}
        deniedText="ZATVORI"
      />
      <MuiDialog
        maxWidth="xl"
        open={openDeloviDialog}
        title="Delovi"
        content={
          <GridProviderDelovi data={deloviData} isLoading={isLoadingDelovi} />
        }
        handleClose={() => setOpenDeloviDialog(false)}
        deniedText="ZATVORI"
      />
      <MuiDialog
        maxWidth="xl"
        open={openTroskoviDialog}
        title="Troškovi"
        content={
          <GridProviderTroskovi
            data={troskoviData}
            isLoading={isLoadingTroskovi}
          />
        }
        handleClose={() => setOpenTroskoviDialog(false)}
        deniedText="ZATVORI"
      />
    </>
  );
};

export default PanelProvider;
